var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useEffect, useRef, useState } from 'react';
export const useEffectOnce = (callback) => {
    _react_refresh_temp_1();
    const cleanupCallback = useRef(() => { });
    const isEffectCalled = useRef(false);
    const isRenderedAfterEffect = useRef(false);
    // eslint-disable-next-line react/hook-use-state -- Intentional
    const [, forceUpdate] = useState({});
    // Because the component is guaranteed
    // to be rendered once, we block
    // the first cleanup with the
    // `isRenderedAfterEffect` flag (row 43)
    // That's why we need to unblock it (row 37),
    // ensuring a second rerender
    if (isEffectCalled.current) {
        isRenderedAfterEffect.current = true;
    }
    useEffect(() => {
        // Executes effect only once
        if (!isEffectCalled.current) {
            cleanupCallback.current = callback();
            isEffectCalled.current = true;
        }
        // In StrictMode the component
        // in which this effect lives
        // is rendered once but we prevent
        // the code to the cleanup function.
        // That's why we need to trigger
        // another rerender to unblock (row 12)
        // the final cleanup code
        forceUpdate({});
        return () => {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises -- Intentional
            (async () => {
                // This prevents cleanup to be called
                // after the first effect is cleaned up
                // in StrictMode
                if (!isRenderedAfterEffect.current) {
                    return;
                }
                const func = await cleanupCallback.current;
                if (typeof func === 'function') {
                    // eslint-disable-next-line @typescript-eslint/await-thenable -- Intentional
                    await func();
                }
            })();
        };
    }, []);
};
_react_refresh_temp_1(useEffectOnce, "pYXQxoeX3ZxbIN69cn3rBmsD/QU=");
